export const data = {
  data: {
    clientContract: {
      table: {
        ref: 'Ref. Cliente',
        description: 'Descrição',
        price: 'Preço',
        agreed: 'Quilogramas Acordados (KG)',
        available: 'Quilogramas Pendentes (KG)',
        lastOrder: 'Data do Último Pedido',
        validity: 'Data de Validade do Contrato'
      },
    },
  }
};
